import moment from 'moment'

export interface AldResponse {
  message: {
    reponse?: Response
    listeAld: Ald[]
  }
}

interface Response {
  showQueries: boolean
  xmlQuery: string
  xmlResponse: string
  erreur: boolean
  erreurCode: string | null
  erreurMessage: string | null
  messageId: string | null
  severite: string | null
  erreurMessageComplet: string | null
}

interface Ald {
  libelle: string
  code: string
  etat: string
  dateDebut: string
  dateFin: string
  codeCim: string
  libelleCim: null
}

export interface SearchAldiWithCarteVitaleDTO {
  psModel: {
    psNumeroFacturation: string
    psIdentStructure: string
    authentificationMode: number
    codePorteurCPS: string
    RPPS: string
  }
  aldiCV: {
    assureNumSecu: string
    beneficiaireDateNaissance: string
    beneficiaireRang: string
    beneficiaireNumSecu: string
    codeRegime: string
    codeCaisse: string
    codeCentre: string
    numeroSerieCv: string
  }
  fichierInjecte: {
    fichierBase64: string
  }
  assertions: {
    assertionPs: string
    assertionVitale: string
    cpsBase64AuthCertificate: string
    cpsBase64SignatureCertificate: string
  }
  isApcv: boolean
  idJfse: number
}

export class AldiService {
  private static endpoint =
    process.env.REACT_APP_ALDI_SERVER || process.env.REACT_APP_INSI_SERVER || ''

  static async searchWithCarteVitale(
    dto: SearchAldiWithCarteVitaleDTO,
  ): Promise<AldResponse> {
    if (!this.endpoint) {
      throw new Error('ALDI endpoint is not defined')
    }

    const url = `${this.endpoint}/aldi/RechercheAvecCarteVitale`

    const birthDateStr = moment(dto.aldiCV.beneficiaireDateNaissance).format(
      'YYYY-MM-DD',
    )

    const requestBody = {
      ...dto,
      aldiCV: {
        ...dto.aldiCV,
        beneficiaireDateNaissance: birthDateStr,
      },
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
      },
      body: JSON.stringify(requestBody),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  }
}
